<template>
  <div class="info">
    <div class="topicimg" :style="'background-image:url('+info.pic_url+')'">
      <div class="topicname">#{{info.name}}#</div>
    </div>
    <div class="content">
      <div class="f-14">{{info.remark}}</div>
      <div class="f-12 c-gray mt-10" v-if="info.user">发起人：{{info.user.user_name}}</div>
      <!-- <div class="f-12 c-gray mt-10"><span v-if="info.read_num>0">阅读：{{info.read_num}} </span> 
        <span v-if="total>0">讨论：{{total}}</span>
      </div> -->
      <div class="f-12 c-gray mt-10">
        <span class="mr-15" v-for="item in relates" :key="'list_' + item.id">{{item.name}}</span>
      </div>
    </div>
    <van-cell v-if="total>0" class="f-15" :title="info.name" :value="total+'条内容'"></van-cell>
    <div class="list" v-if="total>0">
      <!-- <div v-if="list[0].image.length>0">
        <img class="topicimg" :src="list[0].image[0]">
        <div class="pd-15">
          <div class="topictitle ellipsis-2">{{list[0].title}}</div>
          <van-row type="flex" justify="space-between">
            <van-col span="12">
              <span class="binbox">
                <img class="binhand" :src="list[0].user.headimg_url">
                <span class="sourtime">{{list[0].user.user_name}}</span>
              </span>
            </van-col>
            <van-col class="bintright" span="12">
              <img class="binpic" :src="list[0].is_praise==1 ? img.collect_have : img.collect">
              <span class="sourtime">{{list[0].praise_num}}</span>
            </van-col>
          </van-row>
        </div>
      </div>
      <div v-if="list[1].image.length>0">
        <img class="topicimg" :src="list[1].image[0]">
        <div class="pd-15">
          <div class="topictitle ellipsis-2">{{list[1].title}}</div>
          <van-row type="flex" justify="space-between">
            <van-col span="12">
              <span class="binbox">
                <img class="binhand" :src="list[1].user.headimg_url">
                <span class="sourtime">{{list[1].user.user_name}}</span>
              </span>
            </van-col>
            <van-col class="bintright" span="12">
              <img class="binpic" :src="list[1].is_praise==1 ? img.collect_have : img.collect">
              <span class="sourtime">{{list[1].praise_num}}</span>
            </van-col>
          </van-row>
        </div>
      </div> -->
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已加载全部"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="img.loading" />
      </div>
      <van-row class="falls" gutter="10">
        <van-col span="12">
          <div class="itembox" v-for="item in list1" :key="'list1_' + item.id" v-show="item.cover||item.image.length>0">
            <div v-if="item.video" class="videobox" @click="BbsShow(item.id,item.url,item.post_id)">
              <img class="fallsimg" v-lazy="item.cover?item.cover:img.default">
              <img class="videos" :src="img.plays">
            </div>
            <!-- <div v-if="item.video" @click="BbsShow(item.id,item.url)">
              <iframe
              style="z-index:1;"
              :src="item.video"
              allowfullscreen=""
              frameborder="0"
              height="100%"
              width="100%"
              >
            </iframe>
          </div> -->
          <div v-else @click="BbsShow(item.id,item.url,item.post_id)">
            <img class="fallsimg" :src="item.cover?item.cover:item.image[0]">
          </div>
          <div class="pd-15">
            <div  @click="BbsShow(item.id,item.url,item.post_id)" class="topictitle ellipsis-2">{{item.title}}</div>
            <van-row type="flex" justify="space-between">
              <van-col span="12">
                <span class="binbox">
                  <img class="binhand" :src="item.user&&item.user.headimg_url&&item.user.headimg_url.substring(0,5)=='https'?item.user.headimg_url:img.avatar">
                  <span class="sourtime">{{item.user.user_name}}</span>
                </span>
              </van-col>
              <van-col class="bintright" span="12" @click="setPraise(item.id,index)">
                <img class="binpic" :src="item.is_praise==1 ? img.collect_have : img.collect">
                <span class="sourtime">{{item.praise_num}}</span>
              </van-col>
            </van-row>
          </div>
        </div>
      </van-col>
      <van-col span="12" class="bintright">
        <div class="itembox" v-for="item in list2" :key="'list2_' + item.id" v-show="item.cover||item.image.length>0">
          <div v-if="item.video" class="videobox" @click="BbsShow(item.id,item.url,item.post_id)">
            <img class="fallsimg" v-lazy="item.cover?item.cover:img.default">
            <img class="videos" :src="img.plays">
          </div>
          <div v-else @click="BbsShow(item.id,item.url,item.post_id)">
            <img class="fallsimg" :src="item.cover?item.cover:item.image[0]">
          </div>
          <div class="pd-15">
            <div @click="BbsShow(item.id,item.url,item.post_id)" class="topictitle ellipsis-2">{{item.title}}</div>
            <van-row type="flex" justify="space-between">
              <van-col span="12">
                <span class="binbox">
                  <img class="binhand" :src="item.user&&item.user.headimg_url&&item.user.headimg_url.substring(0,5)=='https'?item.user.headimg_url:img.avatar">
                  <span class="sourtime">{{item.user.user_name}}</span>
                </span>
              </van-col>
              <van-col class="bintright" span="12" @click="setPraise(item.id,index)">
                <img class="binpic" :src="item.is_praise==1 ? img.collect_have : img.collect">
                <span class="sourtime">{{item.praise_num}}</span>
              </van-col>
            </van-row>
          </div>
        </div>
      </van-col>
    </van-row>
  </van-list>
</div>
</div>
</template>
<script>
  import topic from '../../../api/content';
  import bbs from '../../../api/bbs';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { List, Cell, CellGroup, Row, Col } from "vant";
  export default {
    data () {
      return {
        info:'',
        loading: false,
        finished: false,
        relates:[],
        params:{
          cid:4,
          page: 1,
          size: 4,
          user_id: 0,
          tname:'',
          topic_id:'',
          source:''
        },
        total:6,
        img:{
          avatar: require('../../../assets/img/lexus/default.png'),
          pic:require('../../../assets/img/lexus/1.png'),
          collect: require('../../../assets/img/lexus/collect.png'),
          collect_have: require('../../../assets/img/lexus/collect_have.png'),
          plays: require('../../../assets/img/lexus/plays.png'),
          default: require('../../../assets/img/default_lexus.png'),
        },
        list:[
        ],
        list1:[],
        list2:[]
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      let id = this.$route.params.id
      if(this.$util.isEmpty(id)) {
        this.$toast('话题不存在')
        return false
      }
      this.id = id
      this.params.topic_id = id
      this.weburl=process.env.VUE_APP_URL
      this.getInfo()
      // this.waterFall()
    },
    methods: {
      getInfo () {
        topic.getTopicShow(this.id).then(res => {
          if(res.data.state == 1) {
            this.info = res.data.data
            this.relates=res.data.data.relates
            if(res.data.data.name){
              document.title = res.data.data.name;
              document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.name)
              document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.remark)
            }
            var apppar={
              title:res.data.data.name
            }
            this.$appService.changeTitle(apppar)
            var params={
              event_code: '话题详情',
              event_id: this.info.id,
              title: this.info.name,
              value: '',
              path: '/Lexus/Bbs/TopicInfo.vue',
              user_id: this.user ? this.user.id : 0,
              source: this.source
            }
            common.BurialPoint(params).then(res => {
              if(res.data.state==1){
              }
            })
          }else{
            var params={
              event_code: '话题详情',
              event_id: '',
              title: '',
              value: '',
              path: '/Lexus/Bbs/TopicInfo.vue',
              user_id: this.user ? this.user.id : 0,
              source: this.source
            }
            common.BurialPoint(params).then(res => {
              if(res.data.state==1){
              }
            })
          }
        })
      },
      waterFall(){
        let list1=[]
        let list2=[]
        let list=this.list
        if(list){
          for (var i = 0 ;i<list.length; i++) {
           if(i%2==0){
            list1.push(list[i])
          }else{
            list2.push(list[i])
          }
        }
        this.list1=list1
        this.list2=list2
      }

    },
    BbsShow(id,url,post_id){
      if(post_id>0){
        var params={
          url:this.weburl+'/lexus/article/'+post_id+'/post'+'?source='+this.source,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }else{
        var params={
          url:this.weburl+'/lexus/bbs/'+id+'?source='+this.source,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }
    },
    onLoad() {
      this.params.user_id = this.user ? this.user.id : 0
      this.params.source = this.source
      setTimeout(() => {
        bbs.getList(this.params).then(res => {
          this.list.push.apply(this.list, res.data.data.data)
          this.params.page += 1
          this.total = res.data.data.total
          this.loading = false
          if(res.data.data.data.length == 0) {
            this.finished = true
          }
          this.waterFall()
        })
      }, 500);
    }
  },
  components:{
    [List.name]: List,
    [Cell.name]:Cell,
    [Row.name]: Row,
    [Col.name]: Col,
    [CellGroup.name]:CellGroup
  }
}
</script>

<style lang="scss">
.info{
  margin-bottom: 50px;
  overflow-x: hidden;
  .topicimg{
    width: 100%;
    height: 230px;
    background-size: cover;
    object-fit: cover;
    color: #fff;
    position: relative;
    background-repeat: no-repeat;
    background-position: center;

    .topicname{
      font-size: 20px;
      padding-top: 100px;
      font-weight: bold;
      color: #fff;
      text-align: center;
    }
  }
  .fallsimg{
    width: 100%;
    height: auto;
  }
  .videobox{
    position: relative;
  }
  .videos{
    width: 18px;
    height: 18px;
    position: absolute;
    left: 45%;
    top: 40%;
  }
  .content{
    padding: 15px;
    .mt-10{
      margin-top: 10px;
    }
    .mr-15{
      margin-right: 15px;
    }
  }
  .van-cell{
    padding: 20px 20px;
    border-top: 10px solid #f8f8f8;
    .van-cell__title{
      color: #9a9a9a;
      font-weight: bold;
    }
    .van-cell__value{
      font-size: 12px;
    }
  }
  .list{
    .pd-15{
      padding: 0 15px 15px 15px; 
      .topictitle{
        font-size: 12px;
        font-weight: bold;
        line-height: 2;
      }
      .binhand{
        width:20px;
        height:20px;
        margin-right:8px;
        vertical-align: middle;
      }
      .binpic{
        width:15px;
        height:15px;
        margin-right:8px;
        vertical-align: middle;
      }
      .sourtime{
        font-size: 12px;
        color: #9A9A9A;
      }
      .bintright{
        text-align:right;
      }
    }
    .falls{
      background-color: #f8f8f8;
      .itembox{
        background-color: #fff;
        margin-bottom: 10px;
      }
    }
  }
  a{
    color: #3a3a3a;
  }
}
</style>
